import { useQuery } from "@apollo/client";
import { useRef } from "react";
import { getEulaInfo } from "../../eula/api/queries/getEulaInfo";
import type { GetEulaInfoQuery, GetEulaInfoQueryVariables } from "../../eula/api/queries/getEulaInfo.gql-generated";

export const useEula = () => {
    const { data, loading, error } = useQuery<GetEulaInfoQuery, GetEulaInfoQueryVariables>(getEulaInfo, {
        fetchPolicy: "network-only",
    });
    const hasResolvedEulaRef = useRef(false);
    const hasResolvedEula = data != undefined || error != undefined;

    if (hasResolvedEula) {
        hasResolvedEulaRef.current = true;
    }

    const isInitialLoading = loading && !hasResolvedEulaRef.current;

    return {
        data,
        loading: isInitialLoading,
        error,
        shouldRedirectToEula:
            !isInitialLoading &&
            hasResolvedEula &&
            (data?.cameraKitMe == null || !data?.cameraKitMe?.me?.hasAgreedToLatestEula),
    };
};
